import React from 'react';
import PaymentSuccessComponent from './PaymentSuccess.component';
import { adaptPaymentSuccessEditorProps } from './PaymentSuccess.adapter';
import { PaymentSuccessEditorProps } from './PaymentSuccess.types';
import './PaymentSuccess.editor.css';

/**
 * 결제 성공 컴포넌트의 에디터 버전
 * 에디터에서 사용할 더미 데이터와 선택 시 스타일을 포함
 */
const PaymentSuccessEditor: React.FC<PaymentSuccessEditorProps> = (originalProps) => {
  // 어댑터를 통해 속성 정규화
  const props = adaptPaymentSuccessEditorProps(originalProps);
  const { isSelected, isPreview, updateComponent, className = "", ...componentProps } = props;
  
  // 선택 상태에 따른 클래스 추가
  const editorClassName = `${className} ${isSelected ? 'selected' : ''}`;
  
  // 기본 스타일 + 에디터 스타일 병합
  const editorStyle = {
    ...componentProps.style,
    position: 'relative' as const,
  };
  
  // 미리보기 모드인 경우 일반 컴포넌트만 렌더링
  if (isPreview) {
    return <PaymentSuccessComponent {...componentProps} />;
  }

  // 에디터 모드에서는 선택 가능한 컴포넌트 렌더링
  return (
    <div className="component-editor">
      <PaymentSuccessComponent
        {...componentProps}
        className={editorClassName}
        style={editorStyle}
      />
    </div>
  );
};

export default PaymentSuccessEditor; 